module.exports = __webpack_public_path__ + "static/media/senior-icon.0c3e697d.png";